export default __webpack_public_path__ + "static/media/shutterstock.6b0649fd.svg";